import { TenantMonthsWorkload } from 'features/Admin/AdminDashboard/AdminDashboard';
import moment from 'moment';
import { OrderStatus } from 'types/enums/OrderStatus';
import Order from '../types/entities/Order';
import Token from 'types/models/Token';

export function base64toBlob(base64Data: string, contentType: string) {
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  // eslint-disable-next-line no-plusplus
  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    // eslint-disable-next-line no-plusplus
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}

export const sortedTenantWorkload = (arrayToSort: TenantMonthsWorkload[]) =>
  arrayToSort.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());

export const getOrderStatusColor = (order: Order | null) => {
  if (!order) {
    return 'neutral.main';
  }
  switch (order.status) {
    case OrderStatus.DRAFTED:
      return 'warning.main';
    case OrderStatus.PENDING:
      return 'primary.main';
    case OrderStatus.VALIDATED:
      return 'success.main';
    case OrderStatus.PRODUCTION:
      return 'primary.main';
    case OrderStatus.CLOSED:
      // return 'closed.main'; PRODUCTION Item differentiation its showing that color in closed tab
      return 'primary.main';
    default:
      return 'neutral.main';
  }
};

export const getCompanyName = (): string => {
  const queryParam = new URLSearchParams(window.location.search).get('company');
  if (queryParam) return queryParam;

  const subDomain = getSubdomain(window.location.hostname);
  if (subDomain && subDomain !== 'localhost') return subDomain;

  return '';
};

export const getSubdomain = (hostname: string): string => {
  // Remove port if exists
  const [cleanHost] = hostname.split(':');
  hostname = cleanHost;

  // Localhost special case
  if (hostname === 'localhost') {
    const companyName = new URLSearchParams(window.location.search).get('company');

    return companyName || 'edelivery';
  }
  const parts = hostname.split('.');

  // Ignore www
  if (parts[0] === 'www') parts.shift();

  // If no subdomain (example.com)
  if (parts.length <= 2) return '';

  // First subdomain only (tenant)
  return parts[0];
};

export const getDecodedIdToken = (cognitoToken: Token): any => {
  try {
    const idToken = cognitoToken?.id_token;
    if (!idToken) return null;

    const parts = idToken.split('.');
    if (parts.length !== 3) return null;

    let payload = parts[1];

    // Convert Base64URL -> Base64
    payload = payload.replace(/-/g, '+').replace(/_/g, '/');

    // Pad if needed
    while (payload.length % 4 !== 0) {
      payload += '=';
    }

    const decoded = atob(payload);

    return JSON.parse(decoded);
  } catch (err) {
    console.error('Failed to decode ID token', err);
    return null;
  }
};
